import React, { Component } from 'react';
import { connect } from 'react-redux';
import actions from '../actions/warranty.actions';
import { Col, Row, Form, Modal, Select, Input, Upload, Icon, DatePicker } from 'antd';
import { dspxGetChildrensContractor } from '../helpers/dspx-utils'
import PhoneNumberInput from '../components/phone-input';
import IconCheckBox from '../components/icon-checkbox';
import { RubleIcon } from '../resource/icons';
import moment from 'moment';
import ContractorRef from '../components/contractor-ref';
import { fromDateStr, toDateStr } from '../helpers/utcDate';


const WarrantyInfoForm = Form.create()(
	class extends React.Component {

		constructor(props) {
			super(props)

			this.state = {
				docTitle: undefined,
			}
		}

		render() {
			const { visible, onCancel, onCreate, form, fprops } = this.props;
			const i = fprops.warrantyInfo
			const { getFieldDecorator } = form;

			return (
				<Modal
					width={520}
					visible={visible}
					title={"Изменить данные по гарантии"}
					okText={"Изменить"}
					onCancel={onCancel}
					onOk={onCreate} >
					<Form layout="vertical">
						{getFieldDecorator('requestId', { initialValue: fprops.request })(
							<Input type='hidden' />)}

						<Row gutter={8}>
							<Col span={22}>
								<Form.Item label="Подрядчик">
									{getFieldDecorator('orgId', {
										initialValue: i.orgId ? '' + i.orgId : undefined,
										rules: [{ required: true, message: 'Пожалуйста, выберите организацию подрядчика' }]
									})(
										<Select
											showSearch
											placeholder="подрядчик"
											notFoundContent='нет данных'
											optionFilterProp="searchtext"
										//onChange={this.handleDocTypeCHange}
										>
											{dspxGetChildrensContractor(fprops.contractors)}
										</Select>)}
								</Form.Item>
							</Col>
							<Col span={2}>
								<ContractorRef style={{ paddingTop: 28 }}
									addCreatedOrg={(createdOrgId) => {
										if (!form.getFieldValue(`orgId`)) {
											form.setFieldsValue({ [`orgId`]: `${createdOrgId}` });
										}
								}}/>
							</Col>
						</Row>
						<Row gutter={16}>
							<Col span={8}>
								<Form.Item label="Дата назначения" >
									{getFieldDecorator('startMoment', {
										initialValue: i.startDate ? moment(i.startDate) : moment(),
										rules: [{ required: true, message: 'Пожалуйста укажите дату назначения подрядчика' }]
									})(
										<DatePicker
											allowClear={false}
											format='DD.MM.YYYY'
										//onChange={this.handleDocDateCHange}
										/>

									)}
								</Form.Item>
							</Col>
							<Col span={8}>
								<Form.Item label="Начало работ" >
									{getFieldDecorator('beginMoment', {
										///initialValue: i.beginDate ? moment(i.beginDate) : moment(),
										initialValue: i.beginDate ? moment(i.beginDate) : null,
										rules: [{ required: false, message: 'Пожалуйста укажите дату начала работ по гарантии' }]
									})(
										<DatePicker
											allowClear={true}
											format='DD.MM.YYYY'
										//onChange={this.handleDocDateCHange}
										/>

									)}
								</Form.Item>

							</Col>
							<Col span={8}>
								<Form.Item label="Окончание работ" >
									{getFieldDecorator('endMoment', {
										///initialValue: i.endDate ? moment(i.endDate) : moment().add(1, 'month'),
										initialValue: i.endDate ? moment(i.endDate) : null,
										rules: [{ required: false, message: 'Пожалуйста укажите дату окончания работ по гарантии' }]
									})(
										<DatePicker
											allowClear={true}
											format='DD.MM.YYYY'
										//onChange={this.handleDocDateCHange}
										/>

									)}
								</Form.Item>

							</Col>
						</Row>
						<Row gutter={16}>
							<Col span={8}>
								<Form.Item label="Телефон">
									{getFieldDecorator('contactPhone', {
										initialValue: i.contactPhone,
										rules: [{ required: false, message: 'Пожалуйста введите номер телефона' }]
									})(
										<PhoneNumberInput />)}
								</Form.Item>
							</Col>
							<Col span={16}>
								<Form.Item label="Ф.И.О. контактного лица">
									{getFieldDecorator('contactName', {
										initialValue: i.contactName,
										rules: [{ required: false, message: 'Пожалуйста введите Ф.И.О. контактного лица' }]
									})(
										<Input />)}
								</Form.Item>
							</Col>
						</Row>
					</Form>
				</Modal>
			);
		}
	});

class WarrantyInfoContainer extends Component {
	state = {
		confirmLoading: false,
	};

	componentDidMount() {
		this.props.dispatch(actions.fetchFileTypesList());
	}

	handleCancel = () => {
		this.formRef.props.form.resetFields();
		this.formRef.state.fileList = []
		this.props.dispatch(actions.closeWarrantyInfoModal());
	}

	handleCreate = () => {
		const form = this.formRef.props.form;

		form.validateFields(async (err, values) => {

			if (err) return;

			const v = {
				...values,
				startDate: toDateStr(values.startMoment),
				beginDate: values.beginMoment && fromDateStr(values.beginMoment),
				endDate: values.endMoment && toDateStr(values.endMoment),
			}

			if (typeof this.props.onWarrantyInfoChange === 'function') {
				this.setState({
					confirmLoading: true,
				});

				await this.props.onWarrantyInfoChange(v);

				this.setState({
					confirmLoading: false,
				});
			} else {
				this.props.dispatch(actions.postWarrantyInfo(v));
			}

			form.resetFields();
			this.props.dispatch(actions.closeWarrantyInfoModal());
		});
	}

	saveFormRef = (formRef) => {
		this.formRef = formRef;
	}

	render() {
		return (
			<WarrantyInfoForm
				wrappedComponentRef={this.saveFormRef}
				visible={this.props.warrantyInfoModalVisible}
				//dispatch={this.props.dispatch}
				onCancel={this.handleCancel}
				onCreate={this.handleCreate}
				fprops={this.props}
			/>
		)
	}
}

function mapStateToProps(state) {
	const { warrantyInfoModalVisible, warrantyInfo, request } = state.warrantyStore
	const { contractors } = state.contractorStore;
	return { warrantyInfoModalVisible, warrantyInfo, request, contractors }
}

export default connect(mapStateToProps)(WarrantyInfoContainer);